import React from 'react';
import * as S from './style';
import { Label, Row } from 'components';

export type ItemType = 'ROW' | 'ROW-START' | 'ROW-BETWEEN' | 'SURVEY';

export interface Props {
  children: React.ReactNode;
  label?: string;
  itemType?: ItemType;
  itemSpace?: number;
  itemRadius?: number;
  width?: number;
  caption?: React.ReactNode;
  optionalChildren?: React.ReactNode | null;
  rowContainerStyle?: React.CSSProperties;
}

function FormItem({
  children,
  label,
  itemType,
  itemSpace,
  itemRadius,
  caption,
  width,
  optionalChildren,
  rowContainerStyle,
}: Props): React.ReactElement {
  return (
    <Row rowContainerStyle={rowContainerStyle}>
      <S.FormItemContainer>
        <Label
          contents={label}
          fontStyle={'caption'}
          color={'gray_opacity_800'}
        />
        <S.ChildrenContainer
          itemType={itemType}
          itemSpace={itemSpace}
          itemRadius={itemRadius}
          width={width}
        >
          {(() => {
            if (itemType === 'ROW') {
              return <S.ChildrenWrapperRow>{children}</S.ChildrenWrapperRow>;
            } else if (itemType === 'ROW-START') {
              return (
                <S.ChildrenWrapperRowStart>
                  {children}
                </S.ChildrenWrapperRowStart>
              );
            } else if (itemType === 'ROW-BETWEEN') {
              return (
                <S.ChildrenWrapperRowBetween>
                  {children}
                </S.ChildrenWrapperRowBetween>
              );
            } else if (itemType === 'SURVEY') {
              return (
                <S.ChildrenWrapperSurvey>{children}</S.ChildrenWrapperSurvey>
              );
            } else {
              return <S.ChildrenWrapper>{children}</S.ChildrenWrapper>;
            }
          })()}
          {optionalChildren ? (
            <S.OptionalChildrenWrapper>
              {optionalChildren}
            </S.OptionalChildrenWrapper>
          ) : null}
        </S.ChildrenContainer>
        {caption ? <S.CaptionWrapper>{caption}</S.CaptionWrapper> : null}
      </S.FormItemContainer>
    </Row>
  );
}

export default FormItem;
